import React, { createContext, useContext, useMemo } from 'react';
import { normalizeApiBaseUrl } from '@/lib/api';

const ApiContext = createContext(null);

export const ApiProvider = ({ children }) => {
  // Memoize so the context value is referentially stable across re-renders,
  // preventing unnecessary useEffect re-runs in consumers.
  const value = useMemo(() => ({
    API_BASE_URL: normalizeApiBaseUrl(process.env.REACT_APP_API_URL),
  }), []);

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApi = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within ApiProvider');
  }
  return context;
};

